import { useApolloClient } from "@apollo/client";
import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { QUERY_GET_LIMITS } from "common/src/graphql/queries";

export function checkSWEDepositLimit(pages, country) {
  const history = useHistory();
  const apolloClient = useApolloClient();

  useEffect(() => {
    async function getLimits() {
      const { loading, errors, data } = await apolloClient.query({
        query: QUERY_GET_LIMITS,
      });
      if (loading) return <h3>Loading ...</h3>;
      if (errors) return false;
      return data.getLimits.limits;
    }
    // console.log("check is set limit for swe");
    let hasTimelimitDaily = false;
    let hasTimelimitWeekly = false;
    let hasTimelimitMonthly = false;
    let hasDepositLimit = false;
    getLimits().then((limits) => {
      limits &&
        limits.forEach((limit) => {
          if (limit.limit === "deposit") {
            hasDepositLimit = true;
          }
          if (
            limit.limitType === "daily_timelimit" &&
            limit.initialAmount > 0
          ) {
            hasTimelimitDaily = true;
          }
          if (
            limit.limitType === "monthly_timelimit" &&
            limit.initialAmount > 0
          ) {
            hasTimelimitMonthly = true;
          }
          if (
            limit.limitType === "weekly_timelimit" &&
            limit.initialAmount > 0
          ) {
            hasTimelimitWeekly = true;
          }
          // console.log(hasDepositLimit + " " + hasTimelimitDaily + " " + hasTimelimitMonthly + " " + hasTimelimitWeekly)
        });
      if (
        !hasDepositLimit ||
        !hasTimelimitDaily ||
        !hasTimelimitWeekly ||
        !hasTimelimitMonthly
      ) {
        // console.log("should redirect!");
        localStorage.setItem("sweSetDepositLimit", "show");
        history.push({ pathname: pages["my-limits"], tab: 1 });
      }
    });
  }, [country, apolloClient]);
}
